import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = { class: "desktop qr-block" }
const _hoisted_3 = { class: "qr-code-wrapper" }
const _hoisted_4 = { ref: "qrCode" }
const _hoisted_5 = {
  key: 0,
  class: "alfapay-warning"
}
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  key: 0,
  class: "payments-block__middle replenishment-type"
}
const _hoisted_8 = { class: "replenishment-type__bank" }
const _hoisted_9 = { class: "replenishment-type__number" }
const _hoisted_10 = { class: "replenishment-type__bank-logo" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 1,
  class: "for-copy replenishment-type__account-number"
}
const _hoisted_14 = {
  key: 0,
  class: "replenishment-type__name"
}
const _hoisted_15 = {
  key: 0,
  style: {"display":"flex","align-items":"center","justify-content":"center","gap":"4px"}
}
const _hoisted_16 = {
  key: 1,
  style: {"display":"flex","align-items":"center","justify-content":"center","gap":"4px"}
}
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "mobile" }
const _hoisted_19 = {
  key: 0,
  class: "alfapay-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SberpayButton = _resolveComponent("SberpayButton")!
  const _component_TPayButton = _resolveComponent("TPayButton")!
  const _component_AlfapayButton = _resolveComponent("AlfapayButton")!
  const _component_VTBPayButton = _resolveComponent("VTBPayButton")!
  const _component_GazprombankButton = _resolveComponent("GazprombankButton")!
  const _component_PSBPayButton = _resolveComponent("PSBPayButton")!
  const _component_OzonPayButton = _resolveComponent("OzonPayButton")!
  const _component_WBPayButton = _resolveComponent("WBPayButton")!
  const _component_SovkomPayButton = _resolveComponent("SovkomPayButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, null, 512)
      ]),
      (_ctx.flow === _ctx.FlowType.ALFAPAY)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('invoice.alfapay-warning')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.deal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(`methods.${_ctx.deal.paymentMethod}`)), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: _ctx.paymentMethodsHelper.getLogo(_ctx.deal.paymentMethod)
                }, null, 8, _hoisted_11)
              ]),
              (_ctx.requisitesLink)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.requisitesLink.href,
                    target: "_blank",
                    rel: "noopener",
                    class: "for-copy replenishment-type__account-number replenishment-type__link"
                  }, _toDisplayString(_ctx.requisitesLink.hostname), 9, _hoisted_12))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.deal.requisites.requisites), 1)),
              _createElementVNode("a", {
                class: "copy-link",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.copy(_ctx.$el, _ctx.deal.requisites.requisites)), ["prevent"]))
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("svg", {
                  width: "20",
                  height: "20",
                  viewBox: "0 0 20 20",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", { d: "M6.99994 3.49991C6.99994 3.10208 7.15797 2.72055 7.43928 2.43925C7.72058 2.15794 8.10211 1.99991 8.49994 1.99991H12.3789C12.7766 2.00026 13.1579 2.15852 13.4389 2.43991L16.5609 5.55991C16.7003 5.69938 16.8108 5.86497 16.8862 6.0472C16.9615 6.22943 17.0002 6.42472 16.9999 6.62191V12.4999C16.9999 12.8977 16.8419 13.2793 16.5606 13.5606C16.2793 13.8419 15.8978 13.9999 15.4999 13.9999H14.4999V10.6209C14.4998 9.82532 14.1836 9.06239 13.6209 8.49991L10.4999 5.37891C9.93746 4.81626 9.17452 4.50008 8.37894 4.49991H6.99994V3.49991Z" }),
                  _createElementVNode("path", { d: "M4.50006 5.99997C4.10224 5.99997 3.72071 6.15801 3.4394 6.43931C3.1581 6.72061 3.00006 7.10215 3.00006 7.49997V16.5C3.00006 16.8978 3.1581 17.2793 3.4394 17.5606C3.72071 17.8419 4.10224 18 4.50006 18H11.5001C11.8979 18 12.2794 17.8419 12.5607 17.5606C12.842 17.2793 13.0001 16.8978 13.0001 16.5V10.621C12.9997 10.2233 12.8414 9.84201 12.5601 9.56097L9.44006 6.43897C9.30059 6.29958 9.135 6.18907 8.95277 6.11374C8.77054 6.03841 8.57525 5.99975 8.37806 5.99997H4.50006Z" })
                ], -1)
              ]))
            ]),
            (_ctx.deal.requisites.holder || _ctx.deal.requisites.swift || _ctx.invoice.crossBorderCurrency)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_ctx.deal.requisites.holder)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createTextVNode(_toDisplayString(_ctx.$t('invoice.tooltip.holder')) + ": ", 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.deal.requisites.holder), 1),
                        _createElementVNode("a", {
                          class: "copy-link",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.copy(_ctx.$el, _ctx.deal.requisites.holder)), ["prevent"]))
                        }, _cache[13] || (_cache[13] = [
                          _createElementVNode("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", { d: "M6.99994 3.49991C6.99994 3.10208 7.15797 2.72055 7.43928 2.43925C7.72058 2.15794 8.10211 1.99991 8.49994 1.99991H12.3789C12.7766 2.00026 13.1579 2.15852 13.4389 2.43991L16.5609 5.55991C16.7003 5.69938 16.8108 5.86497 16.8862 6.0472C16.9615 6.22943 17.0002 6.42472 16.9999 6.62191V12.4999C16.9999 12.8977 16.8419 13.2793 16.5606 13.5606C16.2793 13.8419 15.8978 13.9999 15.4999 13.9999H14.4999V10.6209C14.4998 9.82532 14.1836 9.06239 13.6209 8.49991L10.4999 5.37891C9.93746 4.81626 9.17452 4.50008 8.37894 4.49991H6.99994V3.49991Z" }),
                            _createElementVNode("path", { d: "M4.50006 5.99997C4.10224 5.99997 3.72071 6.15801 3.4394 6.43931C3.1581 6.72061 3.00006 7.10215 3.00006 7.49997V16.5C3.00006 16.8978 3.1581 17.2793 3.4394 17.5606C3.72071 17.8419 4.10224 18 4.50006 18H11.5001C11.8979 18 12.2794 17.8419 12.5607 17.5606C12.842 17.2793 13.0001 16.8978 13.0001 16.5V10.621C12.9997 10.2233 12.8414 9.84201 12.5601 9.56097L9.44006 6.43897C9.30059 6.29958 9.135 6.18907 8.95277 6.11374C8.77054 6.03841 8.57525 5.99975 8.37806 5.99997H4.50006Z" })
                          ], -1)
                        ]))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.deal.requisites.swift)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createTextVNode(_toDisplayString(_ctx.$t('invoice.tooltip.swift')) + ": ", 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.deal.requisites.swift), 1),
                        _createElementVNode("a", {
                          class: "copy-link",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.copy(_ctx.$el, _ctx.deal.requisites.swift)), ["prevent"]))
                        }, _cache[14] || (_cache[14] = [
                          _createElementVNode("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", { d: "M6.99994 3.49991C6.99994 3.10208 7.15797 2.72055 7.43928 2.43925C7.72058 2.15794 8.10211 1.99991 8.49994 1.99991H12.3789C12.7766 2.00026 13.1579 2.15852 13.4389 2.43991L16.5609 5.55991C16.7003 5.69938 16.8108 5.86497 16.8862 6.0472C16.9615 6.22943 17.0002 6.42472 16.9999 6.62191V12.4999C16.9999 12.8977 16.8419 13.2793 16.5606 13.5606C16.2793 13.8419 15.8978 13.9999 15.4999 13.9999H14.4999V10.6209C14.4998 9.82532 14.1836 9.06239 13.6209 8.49991L10.4999 5.37891C9.93746 4.81626 9.17452 4.50008 8.37894 4.49991H6.99994V3.49991Z" }),
                            _createElementVNode("path", { d: "M4.50006 5.99997C4.10224 5.99997 3.72071 6.15801 3.4394 6.43931C3.1581 6.72061 3.00006 7.10215 3.00006 7.49997V16.5C3.00006 16.8978 3.1581 17.2793 3.4394 17.5606C3.72071 17.8419 4.10224 18 4.50006 18H11.5001C11.8979 18 12.2794 17.8419 12.5607 17.5606C12.842 17.2793 13.0001 16.8978 13.0001 16.5V10.621C12.9997 10.2233 12.8414 9.84201 12.5601 9.56097L9.44006 6.43897C9.30059 6.29958 9.135 6.18907 8.95277 6.11374C8.77054 6.03841 8.57525 5.99975 8.37806 5.99997H4.50006Z" })
                          ], -1)
                        ]))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.invoice.crossBorderCurrency)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createTextVNode(_toDisplayString(_ctx.$t('invoice.tooltip.country')) + ": ", 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`countries.${_ctx.invoice.crossBorderCurrency}`)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              (_ctx.flow === _ctx.FlowType.ALFAPAY)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('invoice.alfapay-warning')), 1))
                : _createCommentVNode("", true),
              (_ctx.flow === _ctx.FlowType.SBERPAY)
                ? (_openBlock(), _createBlock(_component_SberpayButton, {
                    key: 1,
                    "onBtn:click": _cache[3] || (_cache[3] = ($event: any) => (_ctx.openDeeplink()))
                  }))
                : (_ctx.flow === _ctx.FlowType.TPAY)
                  ? (_openBlock(), _createBlock(_component_TPayButton, {
                      key: 2,
                      "onBtn:click": _cache[4] || (_cache[4] = ($event: any) => (_ctx.openDeeplink()))
                    }))
                  : (_ctx.flow === _ctx.FlowType.ALFAPAY)
                    ? (_openBlock(), _createBlock(_component_AlfapayButton, {
                        key: 3,
                        "onBtn:click": _cache[5] || (_cache[5] = ($event: any) => (_ctx.openDeeplink()))
                      }))
                    : (_ctx.flow === _ctx.FlowType.VTBPAY)
                      ? (_openBlock(), _createBlock(_component_VTBPayButton, {
                          key: 4,
                          "onBtn:click": _cache[6] || (_cache[6] = ($event: any) => (_ctx.openDeeplink()))
                        }))
                      : (_ctx.flow === _ctx.FlowType.GPBPAY)
                        ? (_openBlock(), _createBlock(_component_GazprombankButton, {
                            key: 5,
                            "onBtn:click": _cache[7] || (_cache[7] = ($event: any) => (_ctx.openDeeplink()))
                          }))
                        : (_ctx.flow === _ctx.FlowType.PSBPAY)
                          ? (_openBlock(), _createBlock(_component_PSBPayButton, {
                              key: 6,
                              "onBtn:click": _cache[8] || (_cache[8] = ($event: any) => (_ctx.openDeeplink()))
                            }))
                          : (_ctx.flow === _ctx.FlowType.OZONPAY)
                            ? (_openBlock(), _createBlock(_component_OzonPayButton, {
                                key: 7,
                                "onBtn:click": _cache[9] || (_cache[9] = ($event: any) => (_ctx.openDeeplink()))
                              }))
                            : (_ctx.flow === _ctx.FlowType.WBPAY)
                              ? (_openBlock(), _createBlock(_component_WBPayButton, {
                                  key: 8,
                                  "onBtn:click": _cache[10] || (_cache[10] = ($event: any) => (_ctx.openDeeplink()))
                                }))
                              : (_ctx.flow === _ctx.FlowType.SOVKOMPAY)
                                ? (_openBlock(), _createBlock(_component_SovkomPayButton, {
                                    key: 9,
                                    "onBtn:click": _cache[11] || (_cache[11] = ($event: any) => (_ctx.openDeeplink()))
                                  }))
                                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([{'visible': !!_ctx.copyHintTimeout}, "copy-container"])
            }, _toDisplayString(_ctx.$t('invoice.tooltip.copied')) + ": " + _toDisplayString(_ctx.copyValue), 3)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}